import { render, staticRenderFns } from "./Oxxo.vue?vue&type=template&id=48fa2612&scoped=true"
import script from "./Oxxo.vue?vue&type=script&lang=ts"
export * from "./Oxxo.vue?vue&type=script&lang=ts"
import style0 from "./Oxxo.vue?vue&type=style&index=0&id=48fa2612&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa2612",
  null
  
)

export default component.exports